import Component from './billing_history_table.vue'
export default Component
